export const optionTag = 'e2e';

export const selectorDatasetTag = 'cy';
